export default class IconHelper {
    static getSvgHref(iconId, cssClasses, fill) {
        const style = fill ? ` style="fill:${fill}"` : '';

        if (!cssClasses) {
            cssClasses = '';
        }

        return `<svg class="icon ${iconId} ${cssClasses}"${style}><use xmlns="http://www.w3.org/2000/svg" xlink:href="#${iconId}"></use></svg>`;
    }
}